import { AggregateMethod } from 'app/shared/model/enumerations/aggregate-method.model';
import { IndicatorType } from 'app/shared/model/enumerations/indicator-type.model';

export interface IIndicator {
  id?: number;
  name?: string | null;
  unit?: string | null;
  aggregateMethod?: AggregateMethod | null;
  description?: string | null;
  type?: IndicatorType | null;
}

export const defaultValue: Readonly<IIndicator> = {};
